var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticStyle: { color: "whitesmoke", "background-color": "gray" },
      attrs: { fluid: "", "fill-height": "" },
    },
    [
      _c(
        "v-slide-y-transition",
        { attrs: { mode: "out-in" } },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "", "justify-center": "" } },
            [
              _c("img", {
                staticClass: "mb-5",
                attrs: {
                  src: require("@/assets/logo.png"),
                  alt: "Brunello Cucinelli",
                },
              }),
              _c("blockquote", [
                _vm._v(" “Beauty will save the world” "),
                _c("footer", [
                  _c("small", [_c("em", [_vm._v("—Fyodor Dostoyevsky")])]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }